
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { CTASection } from "@/sections/CTASection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { VideoSection } from "@/sections/VideoSection";

const XdToPsd = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/XDToPSD"
        ogImage="/images/xd2psd-og-image.jpg"
      />

      <MagicianSection
        title={t("page/XDToPSD:title")}
        subtitle={t("page/XDToPSD:subtitle")}
        magicianLogoFile="psd"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ConvertEverythingSection",
        }}
      >
        <Converter />
      </MagicianSection>

      <TrustedBySection />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsGroupLayers"),
          },
          {
            iconType: "SYNC-ICON",
            text: t("section/conversion:badges.supportsAllNativeElements", {
              format: "XD",
            }),
          },
          {
            iconType: "TV",
            text: t("section/conversion:badges.artboardStyleSupport"),
          },
        ]}
        elements={{
          from: {
            iconType: "ADOBEXD",
            image: "/images/xd-preview.jpg",
            title: "Adobe XD Demo Preview",
          },
          to: {
            iconType: "PHOTOSHOP",
            image: "/images/photoshop-preview.jpg",
            title: "Photoshop Demo Preview",
          },
        }}
      />

      <VideoSection
        title={t("page/XDToPSD:section/videoSection.title")}
        subtitle={t("page/XDToPSD:section/videoSection.subtitle")}
        media={{
          type: "PHOTO",
          title: "Upload demo",
          src: "/images/xd-to-psd-demo.jpg",
        }}
        hasBackground
      />

      <ApiTeaserSection
        title={t("page/XDToPSD:section/apiTeaser.title")}
        image={{
          src: "/svgs/illustration.svg",
          alt: "Magician with shield",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.start") }),
        }}
        elements={t("page/XDToPSD:section/apiTeaser.apiTeaserElements", null, {
          returnObjects: true,
        })}
      />
      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection title={t("section/cta:titles.xdToPsdPage")} href="#upload" />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default XdToPsd;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/xd-to-psd',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  